/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetTrackingDetails,
  GetTrackingIdForProBolNumberResponse,
  ListDocumentsResponse,
  PdfResponse,
  ShipmentForTracking,
  TrackingGroup,
  TrackingInfo,
} from '../models/index';
import {
    GetTrackingDetailsFromJSON,
    GetTrackingDetailsToJSON,
    GetTrackingIdForProBolNumberResponseFromJSON,
    GetTrackingIdForProBolNumberResponseToJSON,
    ListDocumentsResponseFromJSON,
    ListDocumentsResponseToJSON,
    PdfResponseFromJSON,
    PdfResponseToJSON,
    ShipmentForTrackingFromJSON,
    ShipmentForTrackingToJSON,
    TrackingGroupFromJSON,
    TrackingGroupToJSON,
    TrackingInfoFromJSON,
    TrackingInfoToJSON,
} from '../models/index';

export interface GetShipmentForTrackingRequest {
    tId: string;
}

export interface GetTrackingByTIdRequest {
    tId: string;
}

export interface GetTrackingDetailsRequest {
    tId: string;
}

export interface GetTrackingDocumentPdfRequest {
    documentId: string;
    tId: string;
}

export interface GetTrackingGroupRequest {
    d: string;
}

export interface GetTrackingIdForProBolNumberRequest {
    proBolNumber: string;
}

export interface GetTrackingPickupPackagePdfRequest {
    tId: string;
}

export interface ListDocumentsForTrackingRequest {
    tId: string;
}

/**
 * 
 */
export class TrackingApi extends runtime.BaseAPI {

    /**
     * Your GET endpoint
     */
    async getShipmentForTrackingRaw(requestParameters: GetShipmentForTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipmentForTracking>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling getShipmentForTracking().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/get-shipment-for-t`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipmentForTrackingFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getShipmentForTracking(requestParameters: GetShipmentForTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipmentForTracking> {
        const response = await this.getShipmentForTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingByTIdRaw(requestParameters: GetTrackingByTIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackingInfo>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling getTrackingByTId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/get-t`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingInfoFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingByTId(requestParameters: GetTrackingByTIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackingInfo> {
        const response = await this.getTrackingByTIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingDetailsRaw(requestParameters: GetTrackingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTrackingDetails>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling getTrackingDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/get-tracking-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTrackingDetailsFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingDetails(requestParameters: GetTrackingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTrackingDetails> {
        const response = await this.getTrackingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingDocumentPdfRaw(requestParameters: GetTrackingDocumentPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getTrackingDocumentPdf().'
            );
        }

        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling getTrackingDocumentPdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/document-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingDocumentPdf(requestParameters: GetTrackingDocumentPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getTrackingDocumentPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingGroupRaw(requestParameters: GetTrackingGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackingGroup>> {
        if (requestParameters['d'] == null) {
            throw new runtime.RequiredError(
                'd',
                'Required parameter "d" was null or undefined when calling getTrackingGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['d'] != null) {
            queryParameters['d'] = requestParameters['d'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/get-tracking-group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingGroupFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingGroup(requestParameters: GetTrackingGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackingGroup> {
        const response = await this.getTrackingGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingIdForProBolNumberRaw(requestParameters: GetTrackingIdForProBolNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTrackingIdForProBolNumberResponse>> {
        if (requestParameters['proBolNumber'] == null) {
            throw new runtime.RequiredError(
                'proBolNumber',
                'Required parameter "proBolNumber" was null or undefined when calling getTrackingIdForProBolNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['proBolNumber'] != null) {
            queryParameters['proBolNumber'] = requestParameters['proBolNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/get-t-id-for-pro-bol-number`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTrackingIdForProBolNumberResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingIdForProBolNumber(requestParameters: GetTrackingIdForProBolNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTrackingIdForProBolNumberResponse> {
        const response = await this.getTrackingIdForProBolNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingPickupPackagePdfRaw(requestParameters: GetTrackingPickupPackagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling getTrackingPickupPackagePdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/pickup-package-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTrackingPickupPackagePdf(requestParameters: GetTrackingPickupPackagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getTrackingPickupPackagePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async listDocumentsForTrackingRaw(requestParameters: ListDocumentsForTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling listDocumentsForTracking().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/t/list-documents-for-t`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async listDocumentsForTracking(requestParameters: ListDocumentsForTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse> {
        const response = await this.listDocumentsForTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
